var HTMLComponent = new JS.Class(EditorComponent, {
  initialize: function(selector) {
    var element = $(selector);
    this.editorID = element.attr('id') || element.attr('name');
  },

  getSaveData: function() {
    return {
      HTMLData: {
        pageHTML: CKEDITOR.instances[this.editorID]
          ? CKEDITOR.instances[this.editorID].getData()
          : '',
        title: $('#title').val(),
        descr: $('#descr').val(),
      },
    };
  },

  onSaveSuccess: function(result) {
    if (CKEDITOR.instances[this.editorID]) {
      CKEDITOR.instances[this.editorID].fire('save');
    }
  },
});
